import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { QuotationService, ForwarderService, AlertService, AuthenticationService} from '../services/index'
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'app/services/api.service';
import { Util } from 'app/utils';
import { Observable } from 'rxjs';
 
@Injectable()
export class AuthGuard implements CanActivate {
 
    constructor(private router: Router, private quotationService:QuotationService, private fwdrService:ForwarderService,
      private cookieService:CookieService, private apiService: ApiService, private alertService: AlertService, private auth:AuthenticationService) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(state.url.indexOf('quotation') < 0 || state.url.indexOf('quotation/main') > -1){
            this.quotationService.initSearchOption();
        }

        if(state.url.indexOf('fwdr') < 0){
            this.fwdrService.initSearch();
        }

        let canAccess:Observable<boolean> = new Observable(
            observer => {
        
                if (!localStorage.getItem('currentUser')) { 
                    this.apiService.getToken(res => {
                    if (localStorage.getItem('currentUser')) {
                        observer.next(true);            
                    } else {
                        this.alertService.error('접속 권한이 없는 사용자입니다.');
                        setTimeout(() => {
                            this.auth.logout();
                        }, 2000);
                        observer.next(false);            
                    }
                });
                } else {
                    observer.next(true);    
                }
        
            });
        return canAccess;
    }
}


// WEBPACK FOOTER //
// ./src/app/guard/auth.guard.ts